import i18n from "../../../../utils/i18n";
import classes from "./commonRouting.module.scss";

const Radio = ({ checked }) => (
  <span
    className={`${classes.radio} ${checked ? classes.radioChecked : ""}`}
    aria-hidden="true"
  />
);

const ROUTING_OPTIONS = [
  {
    value: "existing",
    title: i18n.t("searchflow.routingexistingtitle"),
    subtitle: i18n.t("searchflow.routingexistingsubtitle"),
  },
  {
    value: "founding",
    title: i18n.t("searchflow.routingfoundingtitle"),
    subtitle: i18n.t("searchflow.routingfoundingsubtitle"),
  },
];

const CommonRouting = ({ routingSelection, onRoutingChange }) => {
  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>
                {i18n.t("searchflow.routingtitle")}
              </h1>
              <p className={classes.subtitle}>
                {i18n.t("searchflow.routingsubtitle")}
              </p>
            </header>

            <div className={classes.rightColumn}>
              <div className={classes.cardsContainer}>
                {ROUTING_OPTIONS.map((option) => {
                  const isSelected = routingSelection === option.value;

                  return (
                    <button
                      key={option.value}
                      type="button"
                      className={`${classes.card} ${isSelected ? classes.selectedRow : ""}`}
                      onClick={() => onRoutingChange(option.value)}
                      aria-pressed={isSelected}
                    >
                      <div className={classes.cardContent}>
                        <div className={classes.cardTitle}>{option.title}</div>
                        {option.subtitle && (
                          <div className={classes.cardSubtitle}>{option.subtitle}</div>
                        )}
                      </div>
                      <Radio checked={isSelected} />
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonRouting;
